import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { ProcessOption } from 'data/processOption/processOption.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import ActionMenus from 'components/ActionMenus';
import DialedDigitExtractionServerGridActionMenu from '../ProcessOptionsGridActionMenu';

interface Props {
  data: ProcessOption[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedProcessOptions: ProcessOption,
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onShowActionMenuItem: (menuId: string, data: ProcessOption[]) => void
  onDeleteRow: () => void;
  onEdit: () => void;
}

const ProcessOptionsGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedProcessOptions,
  onDeleteRow,
  onEdit,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onShowActionMenuItem,
  onSelectItemMenuAction,
}: Props) => {

  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }} data-testid="ProcessOptionsList">
      <CommonGrid
        createNewText={t('processOptions.grid.newProcessOptions')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        actionMenuClass={DialedDigitExtractionServerGridActionMenu}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        showActionMenuItem={onShowActionMenuItem}
        onActionMenuItemClick={onSelectItemMenuAction}
        lastUpdatedAt={lastUpdatedAt}
      >
        <ActionMenus
          name={selectedProcessOptions?.PROCNAME}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          deleteTitle={t('processOptions.deletePopup.title')}
          deleteMessage={t('dialedDigitExtractionServer.deletePopup.message', { msid: selectedProcessOptions?.PROCNAME })}
          onEdit={onEdit}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default ProcessOptionsGrid;
